import { tss } from 'tss-react/mui';

const useStyles = tss
  .withParams<{
    widgetsCollapsed?: boolean;
  }>()
  .create(({ theme, widgetsCollapsed }) => ({
    tab: {
      color: theme.vars.palette.text.secondary,
      [theme.breakpoints.down('md')]: {
        fontSize: '0.75rem',
        minWidth: '3rem'
      }
    },
    vmpPage: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%'
    },
    vmpPageContent: {
      display: 'grid',
      flex: 1,
      height: '100%',
      gap: '1.5rem',
      gridTemplateColumns: widgetsCollapsed
        ? 'auto'
        : 'auto minmax(350px, 20vw)',
      gridTemplateRows: 'repeat(3, minmax(0, 1fr))',
      [theme.breakpoints.down('xl')]: {
        gridAutoFlow: 'row',
        gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
        gridTemplateRows: 'repeat(1, minmax(18.75rem, 1fr))'
      },
      [theme.breakpoints.down('md')]: {
        gridTemplateColumns: 'auto',
        gridTemplateRows: widgetsCollapsed ? 'auto' : 'repeat(5, auto)'
      }
    },
    vmpTable: {
      gridRow: 'span 3',
      overflow: 'auto',
      minHeight: 300,
      [theme.breakpoints.down('xl')]: {
        gridColumn: 'span 3',
        gridRow: widgetsCollapsed ? 'span 2' : 'span 1'
      },
      [theme.breakpoints.down('md')]: {
        gridColumn: 'span 1',
        gridRow: 'span 1',
        height: '100%',
        overflowX: 'auto'
      }
    },
    vmpTablePaper: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      overflow: 'hidden'
    },
    vmpTableSearchBox: {
      backgroundColor: 'var(--mui-palette-background-elevation1)',
      borderBottom: 'solid 1px var(--mui-palette-border-light)',
      '.quickSearch': {
        maxWidth: '20rem'
      },
      display: 'flex',
      justifyContent: 'space-between',
      padding: '0.5rem 1rem'
    },
    vmpTableWrapperBox: {
      height: '100%',
      overflowX: 'auto'
    },
    vmpWidget: {
      [theme.breakpoints.up('xl')]: {
        minHeight: '33.33%'
      },
      [theme.breakpoints.down('xl')]: {
        height: '18rem',
        minHeight: '100%',
        gridRow: 'span 1'
      },
      [theme.breakpoints.down('md')]: {
        gridColumn: 'span 1'
      }
    }
  }));

export default useStyles;
